export const CLIENT_ID = {
  DEV: 'sq0idp-OpbVBIzvDX6QmuY4nR9DKQ',
  STAGING: 'sq0idp-KhZy0MIAxoVptZZnH6QnBw',
  PRODUCTION: 'sq0idp-RUsS0mjKFfhlZzpa5lTtwA',
};
